import { graphql } from '@lib/graphql'
import { execute } from '@lib/graphql/execute'
import { CustomerPasswordResetInput } from '@lib/graphql/graphql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getCustomerQueryOptions } from './get-customer'

export const customerPasswordResetMutationDocument = graphql(`
  mutation CustomerPasswordReset($input: CustomerPasswordResetInput!) {
    customerPasswordReset(input: $input) {
      customerAccessToken {
        accessToken
        refreshToken
        expiresIn
      }
      errors {
        __typename
        ... on UserError {
          message
        }
      }
    }
  }
`)

export const customerPasswordReset = (input: CustomerPasswordResetInput) => {
  return execute(customerPasswordResetMutationDocument, {
    input,
  })
}

type UseCustomerPasswordResetOptions = {
  mutationConfig?: MutationConfig<typeof customerPasswordReset>
}

export const useCustomerPasswordReset = ({
  mutationConfig,
}: UseCustomerPasswordResetOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryOptions().queryKey,
      })
      onSuccess?.(...args)
    },
    ...restConfig,
    mutationFn: customerPasswordReset,
  })
}
